import { call, select, SagaReturnType } from "redux-saga/effects";
import { makeSelectAuthenticatedUserInfo } from "../../../../../containers/App/selectors";
import { isInternalOffice } from "../../../../../utils/isInternalOffice";
import dictionaryContractorsApi from "../contractors/contractors.api";

import { dictionaryApiService } from "../../../../actionService/apiService";
import { ApiCallResult } from "../../../../types";
import { ShortBitrixCompanyDto } from "../../../../../dto/Dictionaries/BitrixCompanyDto";

import endPoints from "./bitrixCarriers.endpoints";

const dictionaryBitrixCarriersApi = {
  basicInfo: function* () {
    const user: ReturnType<ReturnType<typeof makeSelectAuthenticatedUserInfo>> = yield select(makeSelectAuthenticatedUserInfo());
    if (isInternalOffice(user?.company.settings.officeType)) {
      const result: SagaReturnType<typeof dictionaryContractorsApi.nameInfo> = yield call(dictionaryContractorsApi.nameInfo, ["CARRIER"]);
      return {
        ...result,
        success: result.success
          ? { ...result.success, payload: result.success.payload.map(({ id, name }) => ({ bitrixId: id, name })) }
          : undefined,
      };
    }
    return (yield call([dictionaryApiService, dictionaryApiService.Get], endPoints.basicInfo)) as ApiCallResult<
      Array<ShortBitrixCompanyDto>
    >;
  },
};

export default dictionaryBitrixCarriersApi;
